/* eslint-disable no-self-assign */
import { useState } from 'react';

// Generic imports
import _ from 'lodash';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

// Material UI imports
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';

// Font Awesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare, faHouse } from '@fortawesome/pro-light-svg-icons';

// Local imports

dayjs.extend(duration)
dayjs.extend(relativeTime)

function AutoPricingRow({ autoPricing, onOpen, accounts, emails, onSendUpdate }) {
    const [ timespanJump, setTimespanJump ] = useState(0);
    const [ showAddComment, setShowAddComment ] = useState(false);
    const [ sendingComment, setSendingComment ] = useState(false);
    const [ sendCommentSuccessful, setSendCommentSuccessful ] = useState(false);
    const [ sendCommentError, setSendCommentError ] = useState(false);
    const edited = autoPricing.modified;
    const theme = useTheme();

    function _setShowAddComment(val) {
        setShowAddComment(val);
        setSendCommentError(false);
        setSendCommentSuccessful(false);
    }

    return (
        <Paper sx={{ marginTop: '24px', border: `1px solid ${theme.palette.border1}`, background: theme.palette.panel1, width: '100%' }} fullWidth elevation={0} >
            <CardHeader
                autoPricing={autoPricing}
                onOpen={onOpen}
                accounts={accounts}
            />
            <Alert severity='warning'>
                Our AI system will now learn from the quotes you send to customers, and will be active once you create 700 quotes.
            </Alert>
            <Box sx={{ padding: '6px', display: 'flex', fontWeight: 500 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, color: theme.palette.text.secondary }}>
                    <div style={{ display: 'flex', padding: '6px' }}>
                        <div>
                            <Typography variant='caption' sx={{ fontWeight: 500 }}>
                                Created <b>{dayjs.duration((autoPricing.created - new Date().getTime()) / 1000, 'seconds').humanize(true)}</b>
                            </Typography>
                        </div>
                        {edited && (
                            <div>
                                <Typography variant='caption' sx={{ fontWeight: 500 }}>
                                    &nbsp;|&nbsp;
                                </Typography>
                            </div>
                        )}
                        {edited && (
                            <div>
                                <Typography variant='caption' sx={{ fontWeight: 500 }}>
                                    Last edited <b>{dayjs.duration((autoPricing.modified - new Date().getTime()) / 1000, 'seconds').humanize(true)}</b>
                                </Typography>
                            </div>
                        )}
                        <div>
                            <Typography variant='caption' sx={{ fontWeight: 500 }}>
                                &nbsp;|&nbsp;
                            </Typography>
                        </div>
                        <div>
                            <Typography variant='caption' sx={{ fontWeight: 500 }}>
                                Owner is <b>{autoPricing.owner}</b>
                            </Typography>
                        </div>
                    </div>
                </Box>
                <Button variant='text' onClick={() => onOpen({ autoPricing, newWindow: true })} sx={{ marginTop: '6px', height: '24px', textTransform: 'none' }}>
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    &nbsp;
                    Open in new window
                </Button>
            </Box>
            {(autoPricing.tags || []).length > 0 && (
                <Box sx={{ padding: '6px' }} >
                    {autoPricing.tags.map(tag => (<Chip sx={{ marginRight: '6px' }} label={tag.label} key={tag.label} />))}
                </Box>
            )}
        </Paper>
    );
}

export default AutoPricingRow;
export { CardHeader };

function CardHeader(props) {
    const { autoPricing, onOpen, showAddComment, setShowAddComment, sendingComment } = props;
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', padding: '6px', alignItems: 'center', borderBottom: `1px solid ${theme.palette.border1}` }}>
            <Box sx={{ width: '150px' }}>
                <Chip size='small' label='Pending' color='chip-request-new' />
            </Box>
            <Box>
                <Button variant='text' color='primary' sx={{ color: '#2185D0', textDecoration: 'underline' }} onClick={() => onOpen({ autoPricing })}>
                    <Typography variant='h6' sx={{ textDecoration: 'none', fontWeight: 700, textAlign: 'left' }}>
                        {autoPricing.name}
                    </Typography>
                </Button>
            </Box>
            <Box sx={{ flex: 1 }} />
            <Box sx={{ borderLeft: `1px solid ${theme.palette.border1}`}} >
                <Button sx={{ display: 'flex', alignItems: 'center', textTransform: 'none', color: theme.palette.text.secondary }} onClick={() => onOpen({ autoPricing })}>
                    &nbsp;
                    <FontAwesomeIcon icon={faHouse} />
                    &nbsp;
                    &nbsp;
                    <Typography variant='caption'>
                        Details
                    </Typography>
                    &nbsp;
                </Button>
            </Box>
        </Box>
    );
}